import React from 'react';

export const BoothPageHeader = ({ title, children }) => {
    return (
        <div className="flex flex-row items-center justify-between px-3">
            <h1 className="capitalize text-xl font-bold py-3">
                {title}
            </h1>
            <div>
                {children}
            </div>
        </div>
    )
}

export const BoothCardHeader = ({children}) => {
    return (
        <div className="booth-card-header p-3">
            {children}
        </div>
    )
}
export const BoothCardContent = ({children, edge}) => {
    return (
        <div className={`booth-card-content ${edge ? '' : 'p-3' }`}>
            {children}
        </div>
    )
}
export const BoothCardFooter = ({children}) => {
    return (
        <div className="booth-card-footer p-3">
            {children}
        </div>
    )
}
export const BoothCard = ({ children }) => {
    return (
        <div className="booth-card mb-4 rounded-lg bg-gray-800 border-white border-opacity-10 mx-3">
            {children}
        </div>
    )
}


export const BoothTable = ({children, className}) => {
    return (
        <table className={`booth-table table-responsive w-full ${className}`}>
            {children}
        </table>
    )
}
export const BoothTableHead = ({children, className}) => {
    return (
        <thead className={`border-b border-white border-opacity-20 uppercase text-sm font-bold tracking-wide w-full ${className}`}>
            {children}
        </thead>
    )
}
export const BoothTableBody = ({children, className}) => {
    return (
        <tbody className={`w-full ${className}`}>
            {children}
        </tbody>
    )
}
export const BoothTableRow = ({children, className}) => {
    return (
        <tr className={`w-full px-3 ${className}`}>
            {children}
        </tr>
    )
}
export const BoothTableCell = ({children, className}) => {
    return (
        <td className={`font-semibold ${className}`}>
            {children}
        </td>
    )
}